// Let's pollute the window!!  Put all our newer ES6 modules in here so we can acces them in our older code :)
import * as youlicalendar from '/Scripts/youli.common.calendar.min.js';

Object.assign(window, youlicalendar);